export { default as StarIcon } from "@mui/icons-material/Star";
